<style scoped>
li {
  list-style-type: none;
}
</style>

<template>
  <v-container>
    <v-layout row wrap mt-5 pb-3>
      <v-flex xs12>
        <h3>
          <v-icon large color="yellow">shopping_basket</v-icon>
          Table to Basket
        </h3>
        Please copy and paste your order lines from Excel or any other
        spreadsheet into this table.
        <blockquote>
          Make sure that the columns which contain the
          <strong>Material Number</strong>
          (Evident SKU) and the
          <strong>Quantity</strong>
          are selected in the fields below.
        </blockquote>
      </v-flex>
    </v-layout>
    <v-flex xs12><table-to-basket-stepper></table-to-basket-stepper></v-flex>
  </v-container>
</template>

<script>
import TableToBasketStepper from "@/components/TableToBasketStepper.vue";

export default {
  components: {
    TableToBasketStepper
  }
};
</script>
